export default __webpack_public_path__ + "static/media/video2.7275aa67.mp4";